import React from 'react'
import DropdownInputField from '../../formFields/inputWithDropdownField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <DropdownInputField {...fieldProps} />
))
